import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import WorkspaceItemInaccessibleGuard from 'auth/WorkspaceItemInaccessibleGuard';
import {pathToURL} from 'BenchlingUtil';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import BenchLink from 'link-preview/BenchLink';
import {PMEIProcedureQuery} from 'procedures/worksheets/__generated/PMEIProcedureQuery';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

type Study = ExtractByTypename<
  PMEIProcedureQuery['procedureMethodExecutionInstance'],
  'ProcedureMethodExecutionInstanceNode'
>['procedureRun']['study'];

interface WorksheetStudyLinkProps {
  study: Study;
}

export default function WorksheetStudyLink({study}: WorksheetStudyLinkProps): JSX.Element | null {
  if (isInaccessible(study)) {
    return <WorkspaceItemInaccessibleGuard modelType={ModelTypeConstants.STUDY} inaccessibleInfo={study} />;
  }
  return (
    <BenchLink href={pathToURL(study.editUrl)} className={css(styles.link)}>
      <span>
        <BenchlingIcon icon={ModelTypeConstants.STUDY} /> {study.name}
      </span>
    </BenchLink>
  );
}

const styles = StyleSheet.create({
  link: {
    width: 'fit-content',
    lineHeight: '16px',
    fontSize: '13px',
    marginBottom: '4px',
  },
});
